var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseTableList',{staticClass:"mails-table",attrs:{"table-set-list":_vm.mailist,"display-items":_vm.mails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }